import { default as axios, AxiosRequestConfig } from 'axios';

import { PATH_TO_AUTH_API } from '@shared/constants';

/**
 * Command containing a verification code to verify a phone number.
 * @export
 * @interface VerifyPhoneCommand
 */
export interface VerifyPhoneCommand {
  /**
   * The verification code.
   * @type {string}
   * @memberof VerifyPhoneCommand
   */
  verificationCode: string;
}

const defaultOpts: AxiosRequestConfig = {
  baseURL: PATH_TO_AUTH_API,
};

export const PhoneVerificationApi = {
  sendVerificationCode: (options?: AxiosRequestConfig): Promise<void> => {
    return axios.post('/PhoneVerification/sendCode', {}, { ...defaultOpts, ...options });
  },

  verifyOtp: (data: VerifyPhoneCommand, options?: AxiosRequestConfig): Promise<void> => {
    return axios.post('/PhoneVerification/verifyCode', data, { ...defaultOpts, ...options });
  },
};
